import z from "zod";

import { zSpecification } from "./ZSpecification";

export const zSpecificationCard = zSpecification
  .pick({
    name: true,
    displayName: true,
    description: true,
    definition: true,
  })
  .extend({
    categoryDataCode: z.number().optional(),
  });
export type ZSpecificationCard = z.infer<typeof zSpecificationCard>;
